var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hiden)?_c('div',{staticClass:"footer"},[(_vm.isShowAi)?_c('div',{staticClass:"block"},[_c('img',{staticClass:"footer_icon",attrs:{"src":_vm.footer_icon}}),_c('div',[_vm._v("回答由 AI 生成，内容仅供参考，请仔细甄别。")])]):_vm._e(),(_vm.isShow)?_c('span',{staticClass:"mr-24 block"},[_vm._v("© 2025 江苏户传科技有限公司 版权所有")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }